import { useState } from 'react';
import { ModelOfOrderService } from 'src/database';
import api from 'src/services/api';

const moment = require('moment');

export const useOrderServiceReportscontroller = () => {
	const [loading, setLoading] = useState(false);

	const generateOrderServiceReport = (orderService: ModelOfOrderService) => {
		setLoading(true);
		api.post(
			'order-service',
			{
				ORDEMSERVICO: {
					...orderService,
					DATA_ORDEMSERVICO: moment(orderService.DATA_ORDEMSERVICO).format('DD-MM-yyyy HH:mm:ss'),
					DATA_DEMANDA: moment(orderService.DATA_DEMANDA).format('DD-MM-yyyy HH:mm:ss'),
				},
			},
			{ responseType: 'arraybuffer' }
		)
			.then((response) => {
				let blob = new Blob([response.data], {
					type: 'application/pdf',
				});

				let url = window.URL.createObjectURL(blob);
				let link = document.createElement('a');
				link.href = url;
				link.download = 'file.pdf';
				window.open(link.href);

				setTimeout(() => {
					window.URL.revokeObjectURL(url);
				}, 100);
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
			});
	};

	return {
		getOrderServiceReport: {
			loading,
		},
		handleOrderServiceReport: {
			generateOrderServiceReport,
		},
	};
};
